/**
 * fmtDateOnly — "YYYY-MM-DD" tarih-only string'i yerel kısa tarihe çevirir.
 *
 * Kaynak: pages/AdminAppVersion.js (stats.from_date / to_date) ve
 * components/admin/VersionDistributionCard.jsx (data_quality.cap_hit_dates)
 * arasında paylaşılan tek helper — iki yerde de aynı format/timezone
 * davranışı garanti edilsin diye buraya taşındı.
 */
export function fmtDateOnly(dateStr, lang) {
  if (!dateStr) return null;
  const dt = new Date(`${dateStr}T00:00:00Z`);
  if (Number.isNaN(dt.getTime())) return dateStr;
  try {
    return dt.toLocaleDateString(lang === 'tr' ? 'tr-TR' : 'en-US', { timeZone: 'UTC' });
  } catch {
    return dateStr;
  }
}

export default fmtDateOnly;
